(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-rating"] && !Shopify.designMode) return;
  try {
    /* VC Sterne live: Karten-Sterne gegen die Loox Storefront API prüfen (siehe Kommentar oben) */
  if (!window.vcSterneLive) {
    window.vcSterneLive = true;
    var API = 'https://storefront-api.loox.io/storefront/v1/store/';
    var TTL = 10 * 60 * 1000;
    var MAX = 4;
    var werte = {}, angefragt = {}, warte = [], laeuft = 0, io = null;

    var zahl = function (n) { return (Number(n) || 0).toLocaleString('de-DE'); };
    var komma = function (x) { return (Number(x) || 0).toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }); };
    var wort = function (n) { return Number(n) === 1 ? 'Bewertung' : 'Bewertungen'; };
    var lesen = function (pid) {
      try {
        var o = JSON.parse(window.sessionStorage.getItem('vc-sterne:' + pid) || 'null');
        return o && Date.now() - o.t < TTL ? { n: o.n, a: o.a } : null;
      } catch (e) { return null; }
    };
    var merken = function (pid, b) {
      try { window.sessionStorage.setItem('vc-sterne:' + pid, JSON.stringify({ t: Date.now(), n: b.n, a: b.a })); } catch (e) {}
    };
    var setzen = function (el, b) {
      if (!b.n) { el.style.display = 'none'; return; }
      el.style.display = '';
      var st = el.querySelector('.vc-sterne');
      if (st) st.style.setProperty('--vc-fuell', Math.round(b.a / 5 * 100) + '%');
      var an = el.querySelector('.vc-rating__anzahl');
      if (an) an.textContent = '(' + zahl(b.n) + ')';
      el.setAttribute('aria-label', komma(b.a) + ' von 5 Sternen, ' + zahl(b.n) + ' ' + wort(b.n));
    };
    var alleSetzen = function (pid, b) {
      Array.prototype.forEach.call(document.querySelectorAll('.vc-rating[data-vc-pid="' + pid + '"]'), function (el) { setzen(el, b); });
    };
    var pumpe = function () {
      while (laeuft < MAX && warte.length) {
        (function (job) {
          laeuft++;
          fetch(API + encodeURIComponent(job.store) + '/product-reviews/bottomline/' + encodeURIComponent(job.pid), { credentials: 'omit' })
            .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
            .then(function (j) {
              var b = { n: parseInt(j.totalReviews, 10) || 0, a: Number(j.averageRating) || 0 };
              werte[job.pid] = b;
              merken(job.pid, b);
              alleSetzen(job.pid, b);
            })
            .catch(function () {})
            .then(function () { laeuft--; pumpe(); });
        })(warte.shift());
      }
    };
    var pruefen = function (el) {
      var pid = el.getAttribute('data-vc-pid'), store = el.getAttribute('data-vc-store');
      if (!pid || !store) return;
      if (werte[pid]) { setzen(el, werte[pid]); return; }
      var c = lesen(pid);
      if (c) { werte[pid] = c; alleSetzen(pid, c); return; }
      if (angefragt[pid]) return;
      angefragt[pid] = true;
      warte.push({ pid: pid, store: store });
      pumpe();
    };
    var anmelden = function (wurzel) {
      var liste = [];
      if (wurzel.matches && wurzel.matches('.vc-rating[data-vc-pid]')) liste.push(wurzel);
      if (wurzel.querySelectorAll) liste = liste.concat(Array.prototype.slice.call(wurzel.querySelectorAll('.vc-rating[data-vc-pid]')));
      liste.forEach(function (el) {
        if (el.getAttribute('data-vc-live')) return;
        el.setAttribute('data-vc-live', '1');
        if (io) io.observe(el); else pruefen(el);
      });
    };
    var start = function () {
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (eintraege) {
          eintraege.forEach(function (e) {
            if (!e.isIntersecting) return;
            io.unobserve(e.target);
            pruefen(e.target);
          });
        }, { rootMargin: '300px 0px' });
      }
      anmelden(document.body);
      if ('MutationObserver' in window) {
        new MutationObserver(function (aenderungen) {
          aenderungen.forEach(function (a) {
            Array.prototype.forEach.call(a.addedNodes, function (k) { if (k.nodeType === 1) anmelden(k); });
          });
        }).observe(document.body, { childList: true, subtree: true });
      }
    };
    var spaeter = function () {
      if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 2000 });
      else setTimeout(start, 300);
    };
    if (document.readyState === 'complete') spaeter();
    else window.addEventListener('load', spaeter);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vc-anheften"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vc-anheften')) {
    var vcAnAlle = [];
    // Alle in zwei Durchgängen: erst alles lesen, dann alles schreiben (kein Hin und Her zwischen Layout und Stil)
    var vcAnAlleMessen = function () {
      var liste = vcAnAlle.slice();
      var werte = liste.map(function (el) { return el.lesen(); });
      liste.forEach(function (el, i) { el.schreiben(werte[i]); });
    };
    var vcAnSpaeter = function () { setTimeout(vcAnAlleMessen, 60); setTimeout(vcAnAlleMessen, 400); };
    // Wächst oder schrumpft irgendeine Section (Bilder laden nach, Inhalt kommt später), ändert sich ihr Behälter (main):
    // dann alle neu messen. So stimmt die Fläche auch, wenn eine Section darüber oder dazwischen erst später Höhe bekommt.
    var vcAnBehaelter = window.ResizeObserver ? new ResizeObserver(function () { vcAnAlleMessen(); }) : null;
    var vcAnStart = false;
    customElements.define('vc-anheften', class extends HTMLElement {
      connectedCallback() {
        if (vcAnAlle.indexOf(this) === -1) vcAnAlle.push(this);
        this.flaeche = this.querySelector('.vc-an__flaeche');
        this.marke = this.querySelector(':scope > .vc-editor-marke');
        this.ziel = null;
        this._ist = null;
        var ich = this.closest('.shopify-section') || this.parentElement;
        var beh = ich && ich.parentElement;
        if (vcAnBehaelter && beh && !beh._vcAnBeobachtet) { beh._vcAnBeobachtet = true; vcAnBehaelter.observe(beh); }
        this.messen();
        requestAnimationFrame(this.messen.bind(this));
        if (!vcAnStart) {
          vcAnStart = true;
          window.addEventListener('resize', vcAnAlleMessen);
          window.addEventListener('load', vcAnAlleMessen);
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(vcAnAlleMessen);
          ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder', 'shopify:section:select', 'shopify:block:select'].forEach(function (n) {
            document.addEventListener(n, vcAnSpaeter);
          });
        }
      }
      disconnectedCallback() {
        var i = vcAnAlle.indexOf(this);
        if (i !== -1) vcAnAlle.splice(i, 1);
        if (this._ro) { this._ro.disconnect(); this._ro = null; }
        this.ziel = null;
        this._ist = null;
      }
      /** Die Section, an der dieses Element hängt: die nächste mit Inhalt darüber oder darunter (ohne andere Ebenen und Abstände). */
      zielFinden() {
        var ich = this.closest('.shopify-section') || this.parentElement;
        if (!ich) return null;
        var weg = this.dataset.ziel === 'darunter' ? 'nextElementSibling' : 'previousElementSibling';
        var x = ich[weg];
        while (x) {
          var leer = x.offsetHeight < 4 || x.tagName === 'STYLE' || x.tagName === 'SCRIPT' || x.querySelector(':scope > vc-anheften, :scope > .vc-ebene, :scope > .vc-abstand, :scope > .vc-null');
          if (!leer) return x;
          x = x[weg];
        }
        return null;
      }
      messen() { this.schreiben(this.lesen()); }
      /** Nur lesen: Lage und Größe der Ziel-Section im Verhältnis zu diesem Element. null: gerade nicht zu messen. */
      lesen() {
        if (!this.flaeche || !this.isConnected) return null;
        // Ausgeblendet (z. B. "nur Handy" am Rechner): nichts messen, beim nächsten resize wieder
        if (!this.getClientRects().length) return null;
        var ziel = this.zielFinden();
        if (ziel !== this.ziel) {
          if (this._ro) { this._ro.disconnect(); this._ro = null; }
          this.ziel = ziel;
          if (ziel && window.ResizeObserver) {
            var el = this;
            this._ro = new ResizeObserver(function () { el.messen(); });
            this._ro.observe(ziel);
          }
        }
        var w = { o: 0, l: 0, b: 0, h: 0, ziel: !!ziel, marke: 0 };
        if (ziel) {
          var t = ziel.getBoundingClientRect(), m = this.getBoundingClientRect();
          w.o = Math.round(t.top - m.top); w.l = Math.round(t.left - m.left); w.b = Math.round(t.width); w.h = Math.round(t.height);
        }
        // Im Editor: Etiketten weiterer Sections ohne Höhe an derselben Grenze zählen, damit keins das andere verdeckt
        if (this.marke) {
          var x = (this.closest('.shopify-section') || this).previousElementSibling;
          while (x && x.offsetHeight < 4) { if (x.querySelector('.vc-editor-marke')) w.marke++; x = x.previousElementSibling; }
        }
        return w;
      }
      /** Nur schreiben, und nur, was sich geändert hat. */
      schreiben(w) {
        if (!w) return;
        var alt = this._ist || {};
        this._ist = w;
        if (this.marke && w.marke !== alt.marke) this.marke.style.setProperty('--vc-marke-i', w.marke);
        if (w.ziel !== alt.ziel) {
          this.classList.toggle('vc-an--bereit', w.ziel);
          this.classList.toggle('vc-an--ohne-ziel', !w.ziel);
        }
        if (!w.ziel || (w.o === alt.o && w.l === alt.l && w.b === alt.b && w.h === alt.h && alt.ziel)) return;
        var f = this.flaeche.style;
        f.setProperty('--an-o', w.o + 'px');
        f.setProperty('--an-l', w.l + 'px');
        f.setProperty('--an-b', w.b + 'px');
        f.setProperty('--an-h', w.h + 'px');
        this.dispatchEvent(new CustomEvent('vc:anheften', { detail: { breite: w.b, hoehe: w.h } }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vc-basics"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vc-schiene')) {
    // Eigene Abfragen statt VC.ruhig()/VC.editor(): Shopify garantiert keine Reihenfolge der Skripte, dieses kann vor
    // vc-basis laufen (dann gibt es window.VC noch nicht und Autoplay liefe sonst auch bei weniger Bewegung und im Editor)
    var vcSchRuhig = function () { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); };
    var vcSchEditor = function () { return !!(window.Shopify && window.Shopify.designMode); };
    customElements.define('vc-schiene', class extends HTMLElement {
      connectedCallback() {
        if (this._vcAn) { this.anmelden(); return; }
        this._vcAn = true;
        var el = this;
        this.spur = this.querySelector('[data-sch-spur]');
        if (!this.spur) return;
        // Per Tastatur erreichbar (Pfeiltasten wischen), in allen Browsern, nicht nur in Chromium. Nur solange es etwas
        // zu wischen gibt (zustand): passt alles hinein, wäre die Liste ein überflüssiger Halt beim Tabben.
        if (!this.spur.hasAttribute('tabindex')) { this._tabAuto = true; this.spur.tabIndex = 0; }
        this._update = function () {
          if (el._raf) return;
          el._raf = requestAnimationFrame(function () { el._raf = 0; el.zustand(); });
        };
        this.addEventListener('click', function (e) {
          if (e.target.closest('[data-sch-pause]')) { el.anhalten(!el._gestoppt); return; }
          if (e.target.closest('[data-sch-zurueck]')) { el.blaettern(-1); return; }
          if (e.target.closest('[data-sch-weiter]')) el.blaettern(1);
        });
        // Nach dem Ziehen mit der Maus zählt der Klick nicht (sonst öffnet sich ein Link oder die Lightbox)
        this.spur.addEventListener('click', function (e) {
          if (el._sperre) { e.preventDefault(); e.stopPropagation(); }
        }, true);
        this.spur.addEventListener('dragstart', function (e) { e.preventDefault(); });
        this.spur.addEventListener('keydown', function (e) {
          if (e.target !== el.spur) return;
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            el.schritt(e.key === 'ArrowRight' ? 1 : -1);
          }
        });
        this.spur.addEventListener('scroll', this._update, { passive: true });
        this.ziehenEinrichten();
        // Autoplay: pausiert bei Maus, Fokus und Berührung, nie bei weniger Bewegung
        this._pause = false;
        ['pointerenter', 'focusin', 'touchstart'].forEach(function (n) { el.addEventListener(n, function () { el._pause = true; }, { passive: true }); });
        ['pointerleave', 'focusout'].forEach(function (n) { el.addEventListener(n, function () { el._pause = false; }); });
        this.anmelden();
      }
      anmelden() {
        var el = this;
        if (!this.spur) return;
        if (window.ResizeObserver) {
          this._ro = new ResizeObserver(this._update);
          this._ro.observe(this.spur);
        }
        window.addEventListener('resize', this._update);
        var sek = Number(this.dataset.auto) || 0;
        var auto = sek > 0 && !vcSchRuhig() && !vcSchEditor();
        // Knopf zum Anhalten (WCAG 2.2.2): ein eigener aus dem HTML oder einer oben rechts auf der Bühne
        var halt = this.querySelector('[data-sch-pause]');
        if (auto && !halt) {
          halt = document.createElement('button');
          halt.type = 'button';
          halt.className = 'vc-sch__pause';
          halt.setAttribute('data-sch-pause', '');
          halt.innerHTML = '<svg class="vc-sch__pause-halt" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M5 3v10M11 3v10" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>' +
            '<svg class="vc-sch__pause-weiter" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M5 2.8v10.4L13.2 8z" fill="currentColor"/></svg>';
          // Vor die Liste: wer mit der Tastatur kommt, erreicht das Anhalten vor den laufenden Bildern
          var buehne = this.querySelector('.vc-sch__buehne') || this.spur.parentNode;
          buehne.insertBefore(halt, buehne.firstChild);
        }
        if (halt) { halt.hidden = !auto; this.anhalten(!!this._gestoppt); }
        if (auto) {
          if (window.IntersectionObserver) {
            // Der letzte Eintrag ist der aktuelle (bei schnellem Scrollen kommen mehrere auf einmal)
            this._io = new IntersectionObserver(function (e) { var x = e[e.length - 1]; el._sichtbar = !!(x && x.isIntersecting); });
            this._io.observe(this);
          } else { this._sichtbar = true; }
          this._takt = setInterval(function () {
            if (!el._sichtbar || el._pause || el._gestoppt || document.hidden) return;
            var max = el.spur.scrollWidth - el.spur.clientWidth;
            if (el.spur.scrollLeft >= max - 4) el.spur.scrollTo({ left: 0, behavior: 'smooth' });
            else el.schritt(1);
          }, sek * 1000);
        }
        this._sek = this.closest('.shopify-section');
        if (this._sek && !this._blockWahl) {
          this._blockWahl = function (e) {
            var t = e.target && e.target.closest ? e.target : null;
            if (!t || !el.spur.contains(t)) return;
            var teil = el.teilVon(t);
            if (teil) el.spur.scrollTo({ left: Math.max(0, teil.offsetLeft + teil.offsetWidth / 2 - el.spur.clientWidth / 2), behavior: 'auto' });
          };
          this._sek.addEventListener('shopify:block:select', this._blockWahl);
        }
        this.zustand();
        requestAnimationFrame(this._update);
      }
      disconnectedCallback() {
        if (this._ro) { this._ro.disconnect(); this._ro = null; }
        if (this._io) { this._io.disconnect(); this._io = null; }
        if (this._takt) { clearInterval(this._takt); this._takt = 0; }
        window.removeEventListener('resize', this._update);
        if (this._sek && this._blockWahl) { this._sek.removeEventListener('shopify:block:select', this._blockWahl); this._blockWahl = null; }
      }
      teile() {
        return Array.prototype.filter.call(this.spur.children, function (k) { return k.offsetWidth > 0; });
      }
      teilVon(t) {
        while (t && t.parentElement !== this.spur) t = t.parentElement;
        return t;
      }
      schrittweite() {
        var t = this.teile();
        if (t.length > 1) return Math.abs(t[1].offsetLeft - t[0].offsetLeft) || this.spur.clientWidth;
        return this.spur.clientWidth;
      }
      verhalten() { return vcSchRuhig() ? 'auto' : 'smooth'; }
      schritt(r) {
        this.spur.scrollBy({ left: r * this.schrittweite(), behavior: this.verhalten() });
      }
      blaettern(r) {
        // So viele Teile, wie ganz zu sehen sind (bei 4 sichtbaren 4, nicht 3): die Lücke nach dem letzten zählt mit
        var t = this.teile(), w = this.schrittweite();
        var luecke = t.length > 1 ? Math.max(0, w - t[0].offsetWidth) : 0;
        var n = Math.max(1, Math.floor((this.spur.clientWidth + luecke + 2) / w));
        this.spur.scrollBy({ left: r * n * w, behavior: this.verhalten() });
      }
      /** Automatisches Weiterlaufen anhalten (true) oder wieder starten (false), mit passendem Knopf. */
      anhalten(an) {
        this._gestoppt = !!an;
        var k = this.querySelector('[data-sch-pause]');
        if (!k) return;
        k.setAttribute('aria-label', an ? 'Automatisch weiterlaufen lassen' : 'Automatisches Weiterlaufen anhalten');
        k.classList.toggle('vc-sch__pause--aus', !!an);
      }
      zustand() {
        var s = this.spur;
        if (!s) return;
        var max = s.scrollWidth - s.clientWidth;
        var still = max <= 2;
        this.classList.toggle('vc-sch--still', still);
        if (this._tabAuto) { if (still) s.removeAttribute('tabindex'); else if (s.tabIndex !== 0) s.tabIndex = 0; }
        var x = Math.max(0, s.scrollLeft);
        Array.prototype.forEach.call(this.querySelectorAll('[data-sch-zurueck]'), function (b) { b.disabled = still || x <= 2; });
        Array.prototype.forEach.call(this.querySelectorAll('[data-sch-weiter]'), function (b) { b.disabled = still || x >= max - 2; });
        var balken = this.querySelector('[data-sch-balken]');
        if (balken) {
          balken.style.setProperty('--sch-anteil', Math.min(1, s.clientWidth / Math.max(1, s.scrollWidth)).toFixed(4));
          balken.style.setProperty('--sch-pos', (max > 0 ? Math.min(1, x / max) : 0).toFixed(4));
        }
      }
      ziehenEinrichten() {
        var el = this, s = this.spur, start = null;
        s.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' || e.button !== 0 || el.classList.contains('vc-sch--still')) return;
          start = { x: e.clientX, links: s.scrollLeft, id: e.pointerId, bewegt: false };
        });
        s.addEventListener('pointermove', function (e) {
          if (!start || e.pointerId !== start.id) return;
          var dx = e.clientX - start.x;
          if (!start.bewegt && Math.abs(dx) > 5) {
            start.bewegt = true;
            el.classList.add('vc-sch--zieht');
            try { s.setPointerCapture(e.pointerId); } catch (f) {}
          }
          if (start.bewegt) s.scrollLeft = start.links - dx;
        });
        var ende = function (e) {
          if (!start || (e && e.pointerId !== start.id)) return;
          var bewegt = start.bewegt;
          start = null;
          if (!bewegt) return;
          el._sperre = true;
          setTimeout(function () { el._sperre = false; }, 0);
          // Auf das nächste Teil einrasten
          var w = el.schrittweite();
          var ziel = Math.round(s.scrollLeft / w) * w;
          el.classList.remove('vc-sch--zieht');
          s.scrollTo({ left: ziel, behavior: el.verhalten() });
        };
        s.addEventListener('pointerup', ende);
        s.addEventListener('pointercancel', ende);
        s.addEventListener('lostpointercapture', ende);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vc-basis"] && !Shopify.designMode) return;
  try {
    var VC = window.VC = window.VC || {};
  document.documentElement.classList.add('vc-js');
  VC.ruhig = function () { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); };
  VC.editor = function () { return !!(window.Shopify && window.Shopify.designMode); };
  VC.wurzel = function () { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; };

  /** Preis in Cent als Text, z. B. 2499 -> "24,99 €". */
  VC.preis = function (cent) {
    var w = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: w }).format((Number(cent) || 0) / 100); }
    catch (e) { return ((Number(cent) || 0) / 100).toFixed(2).replace('.', ',') + ' ' + w; }
  };

  /**
   * In den Warenkorb. Der VC Warenkorb sieht die Anfrage selbst und geht auf. Ohne ihn: Warenkorb des Themes
   * (Impact: cart-drawer), sonst die Warenkorb-Seite. Gibt ein Promise, das bei Fehlern mit der Meldung von Shopify abbricht.
   */
  VC.inDenWarenkorb = function (variante, menge) {
    var wurzel = VC.wurzel();
    return window.fetch(wurzel + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variante), quantity: Math.max(1, Number(menge) || 1) }] })
    }).catch(function () {
      throw new Error('Keine Verbindung. Bitte nochmal versuchen.');
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Das hat nicht geklappt. Bitte nochmal versuchen.');
        return j;
      });
    }).then(function (j) {
      if (window.VCWK) return j;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.show === 'function') d.show();
      else window.location.href = wurzel + 'cart';
      return j;
    });
  };

  /** Ansage für Screenreader (eine gemeinsame Zeile für alle VC Sections). */
  VC.melden = function (text) {
    var z = document.getElementById('vc-meldung');
    if (!z) {
      z = document.createElement('div');
      z.id = 'vc-meldung';
      z.setAttribute('role', 'status');
      z.setAttribute('aria-live', 'polite');
      z.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0';
      document.body.appendChild(z);
    }
    z.textContent = '';
    setTimeout(function () { z.textContent = text; }, 60);
  };

  /** Knopf "In den Warenkorb" mit Lade-Zustand und Meldung. Klicks während der Anfrage oder der Meldung zählen nicht. */
  VC.kaufKnopf = function (knopf, variante, menge) {
    if (!knopf || knopf.getAttribute('aria-busy') === 'true' || knopf.dataset.vcMeldung) return;
    if (!knopf.dataset.vcText) knopf.dataset.vcText = knopf.innerHTML;
    knopf.setAttribute('aria-busy', 'true');
    return VC.inDenWarenkorb(variante, menge).then(function () {
      knopf.removeAttribute('aria-busy');
      VC.melden('Im Warenkorb');
    }, function (e) {
      knopf.removeAttribute('aria-busy');
      knopf.dataset.vcMeldung = '1';
      knopf.classList.add('vc-knopf--meldung');
      knopf.textContent = e.message;
      VC.melden(e.message);
      setTimeout(function () {
        knopf.innerHTML = knopf.dataset.vcText;
        knopf.classList.remove('vc-knopf--meldung');
        delete knopf.dataset.vcMeldung;
      }, 2600);
    });
  };

  /**
   * Die sichtbare Hintergrundfarbe an einer Kante einer Section: von innen nach außen das erste Element mit
   * deckender Farbe, das fast die ganze Breite hat. unten=true: an der Unterkante, sonst an der Oberkante.
   * Deckt dort nichts (durchsichtige Section), die Farbe der Seite. null, wenn dort ein Bild oder Verlauf liegt.
   */
  VC.farbeAnKante = function (sektion, unten) {
    if (!sektion) return null;
    var r = sektion.getBoundingClientRect();
    if (r.height < 2) return null;
    var kandidaten = [sektion].concat(Array.prototype.slice.call(sektion.querySelectorAll('*')));
    var treffer = null;
    for (var i = 0; i < kandidaten.length; i++) {
      var el = kandidaten[i];
      var b = el.getBoundingClientRect();
      if (b.width < r.width * 0.9 || b.height < 2) continue;
      if (unten ? Math.abs(b.bottom - r.bottom) > 3 : Math.abs(b.top - r.top) > 3) continue;
      var st = window.getComputedStyle(el);
      if (st.visibility === 'hidden' || st.display === 'none') continue;
      if (st.backgroundImage && st.backgroundImage !== 'none' && !/^url\(.*\.svg/.test(st.backgroundImage)) { treffer = 'bild'; continue; }
      var f = st.backgroundColor;
      var m = /rgba?\(([^)]+)\)/.exec(f || '');
      if (!m) continue;
      var teile = m[1].split(/[\s,\/]+/).filter(Boolean);
      var a = teile.length > 3 ? parseFloat(teile[3]) : 1;
      if (a < 0.95) continue;
      treffer = f;
    }
    if (treffer === 'bild') return null;
    return treffer || VC.seitenFarbe();
  };

  /** Bei "Bewegung reduzieren": Videos mit Autoplay anhalten und die Steuerung zeigen. */
  VC.videosRuhig = function (wurzel) {
    if (!VC.ruhig()) return;
    (wurzel || document).querySelectorAll('.vc-s video[autoplay]').forEach(function (v) {
      v.removeAttribute('autoplay');
      try { v.pause(); } catch (e) {}
      v.controls = true;
    });
  };
  VC.videosRuhig();
  document.addEventListener('shopify:section:load', function (e) { VC.videosRuhig(e.target); });

  /**
   * Die Skripte der Sections liegen als eigene Dateien (assets/vc-*.js) und laden über ein <script> am Ende der Section,
   * also nur auf Seiten, auf denen die Section steht. Fügt der Theme-Editor eine Section ohne Neuladen ein, läuft ein
   * eingefügtes <script> nicht von selbst: dann hier nachladen (jede Datei höchstens einmal).
   */
  VC.skripteNachladen = function (wurzel) {
    var geladen = window.VCJS || {};
    VC._laedt = VC._laedt || {};
    Array.prototype.forEach.call((wurzel || document).querySelectorAll('script[data-vc-js]'), function (s) {
      var name = s.getAttribute('data-vc-js');
      if (!name || !s.src || geladen[name] || VC._laedt[name]) return;
      VC._laedt[name] = true;
      var neu = document.createElement('script');
      neu.src = s.src;
      document.head.appendChild(neu);
    });
  };
  document.addEventListener('shopify:section:load', function (e) { VC.skripteNachladen(e.target); });

  /** Farbe der Seite selbst (body), wenn keine Section deckt. */
  VC.seitenFarbe = function () {
    var f = window.getComputedStyle(document.body).backgroundColor;
    return /rgba?\(/.test(f) && !/,\s*0\)$/.test(f) && f !== 'transparent' ? f : null;
  };
  /** Kante unten an einer Section: holt sich die Farbe vom oberen Rand der nächsten Section mit Inhalt. */
  if (!customElements.get('vc-kante')) {
    var kantenFarben = function () { document.querySelectorAll('vc-kante[data-auto=true]').forEach(function (k) { if (k.farbeHolen) k.farbeHolen(); }); };
    customElements.define('vc-kante', class extends HTMLElement {
      connectedCallback() { if (this.dataset.auto === 'true') { this.farbeHolen(); requestAnimationFrame(this.farbeHolen.bind(this)); } }
      farbeHolen() {
        var ich = this.closest('.shopify-section');
        if (!ich) return;
        var alle = Array.prototype.slice.call(document.querySelectorAll('.shopify-section'));
        var n = null;
        for (var j = alle.indexOf(ich) + 1; j < alle.length; j++) { if (alle[j].getBoundingClientRect().height > 4) { n = alle[j]; break; } }
        var f = n ? VC.farbeAnKante(n, false) : VC.seitenFarbe();
        if (f) this.style.setProperty('--farbe-ist', f); else this.style.removeProperty('--farbe-ist');
      }
    });
    window.addEventListener('load', kantenFarben);
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (n) { document.addEventListener(n, function () { setTimeout(kantenFarben, 120); }); });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vc-lightbox"] && !Shopify.designMode) return;
  try {
    var VC = window.VC = window.VC || {};
  if (!VC.lightbox) {
    var vcLx = null;
    var vcLxBauen = function () {
      var d = document.createElement('dialog');
      d.className = 'vc-lx';
      d.setAttribute('aria-label', 'Bilder');
      // Klick auf Bild oder Rand fokussiert den Dialog selbst (nicht body): Pfeiltasten gehen weiter
      d.tabIndex = -1;
      d.innerHTML = '<div class="vc-lx__kopf"><span class="vc-lx__zaehler" aria-hidden="true"></span><p class="vc-lx__ansage" aria-live="polite"></p><button type="button" class="vc-lx__knopf vc-lx__zu" aria-label="Schließen">&times;</button></div>' +
        '<div class="vc-lx__buehne"><button type="button" class="vc-lx__knopf vc-lx__zurueck" aria-label="Vorheriges Bild">&larr;</button>' +
        '<div class="vc-lx__bildrahmen"><img class="vc-lx__bild" alt="" draggable="false"><iframe class="vc-lx__video" title="Kundenvideo" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen hidden></iframe></div>' +
        '<button type="button" class="vc-lx__knopf vc-lx__weiter" aria-label="Nächstes Bild">&rarr;</button></div>' +
        '<div class="vc-lx__fuss"><p class="vc-lx__titel" hidden></p><p class="vc-lx__text" hidden></p><a class="vc-lx__link" hidden></a></div>';
      document.body.appendChild(d);
      var lb = { d: d, liste: [], i: 0, ausloeser: null, bild: d.querySelector('.vc-lx__bild'), video: d.querySelector('.vc-lx__video') };
      // Video anhalten: Player leeren (sonst läuft der Ton nach dem Weiterklicken oder Schließen weiter)
      lb.videoStopp = function () {
        var v = lb.video;
        if (v.getAttribute('src') && v.getAttribute('src') !== 'about:blank') v.src = 'about:blank';
        v.hidden = true;
      };
      var zu = function () { if (d.open) d.close(); };
      d.querySelector('.vc-lx__zu').addEventListener('click', zu);
      d.querySelector('.vc-lx__zurueck').addEventListener('click', function () { lb.zeigen(lb.i - 1); });
      d.querySelector('.vc-lx__weiter').addEventListener('click', function () { lb.zeigen(lb.i + 1); });
      // Pfeiltasten am Dokument, solange offen: gehen auch, wenn der Fokus gerade nirgends liegt
      document.addEventListener('keydown', function (e) {
        if (!d.open || e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); lb.zeigen(lb.i - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); lb.zeigen(lb.i + 1); }
        // Escape schließt der Browser beim modalen Dialog selbst; ohne showModal (alte Browser) hier
        else if (e.key === 'Escape' && !lb.modal) { e.preventDefault(); zu(); }
      });
      // Klick auf den dunklen Rand schließt (nicht auf Bild, Knöpfe, Texte), aber nicht direkt nach einem Wischen mit der Maus
      d.addEventListener('click', function (e) {
        if (lb.gewischt) { lb.gewischt = false; return; }
        if (e.target === d || e.target.classList.contains('vc-lx__bildrahmen')) { zu(); return; }
        // Das Bild füllt die ganze Fläche: Klick auf den dunklen Rand neben dem Foto schließt trotzdem
        var bi = lb.bild;
        if (e.target === bi && bi.naturalWidth && bi.naturalHeight) {
          var r = bi.getBoundingClientRect(), f = Math.min(r.width / bi.naturalWidth, r.height / bi.naturalHeight);
          var w = bi.naturalWidth * f, h = bi.naturalHeight * f, x0 = r.left + (r.width - w) / 2, y0 = r.top + (r.height - h) / 2;
          if (e.clientX < x0 || e.clientX > x0 + w || e.clientY < y0 || e.clientY > y0 + h) zu();
        }
      });
      d.addEventListener('close', function () {
        lb.videoStopp();
        document.documentElement.classList.remove('vc-lx-offen');
        var a = lb.ausloeser;
        lb.ausloeser = null;
        if (a && a.isConnected && a.focus) { try { a.focus({ preventScroll: true }); } catch (x) { a.focus(); } }
      });
      // Wischen (nicht über einem Video: der Player bekommt die Berührung selbst)
      var start = null;
      var buehne = d.querySelector('.vc-lx__buehne');
      buehne.addEventListener('pointerdown', function (e) { if (e.isPrimary) { start = { x: e.clientX, y: e.clientY, id: e.pointerId }; lb.gewischt = false; } });
      buehne.addEventListener('pointerup', function (e) {
        if (!start || e.pointerId !== start.id) return;
        var dx = e.clientX - start.x, dy = e.clientY - start.y;
        start = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          // Der Klick nach dem Loslassen soll den Dialog nicht schließen
          lb.gewischt = true;
          setTimeout(function () { lb.gewischt = false; }, 0);
          lb.zeigen(lb.i + (dx < 0 ? 1 : -1));
        }
      });
      buehne.addEventListener('pointercancel', function () { start = null; });
      // Zähler und Pfeile passend zur Liste (auch wenn die Liste nachträglich länger wird)
      lb.stand = function () {
        var n = lb.liste.length, i = lb.i;
        d.querySelector('.vc-lx__zaehler').textContent = n > 1 ? (i + 1) + ' von ' + n : '';
        var zurueck = d.querySelector('.vc-lx__zurueck'), weiter = d.querySelector('.vc-lx__weiter');
        zurueck.disabled = i === 0;
        weiter.disabled = i === n - 1;
        zurueck.hidden = n < 2;
        weiter.hidden = n < 2;
      };
      lb.zeigen = function (i) {
        var n = lb.liste.length;
        if (!n) return;
        if (i < 0 || i >= n) return;
        lb.i = i;
        var x = lb.liste[i];
        var b = lb.bild;
        if (x.typ === 'video') {
          b.hidden = true;
          b.classList.remove('vc-lx__bild--laedt');
          if (lb.video.getAttribute('src') !== x.src) lb.video.src = x.src || 'about:blank';
          lb.video.hidden = false;
        } else {
          lb.videoStopp();
          b.hidden = false;
          // Gleiches Bild wie eben: kein neues load-Ereignis, also nicht abdunkeln
          var neu = (x.src || '') !== (b.getAttribute('src') || '');
          b.classList.toggle('vc-lx__bild--laedt', neu);
          b.onload = function () { b.classList.remove('vc-lx__bild--laedt'); };
          b.onerror = function () { b.classList.remove('vc-lx__bild--laedt'); };
          if (x.srcset) { b.srcset = x.srcset; b.sizes = x.sizes || '100vw'; } else { b.removeAttribute('srcset'); b.removeAttribute('sizes'); }
          if (neu) b.src = x.src || '';
          b.alt = x.alt || x.titel || '';
        }
        // Screenreader hören Nummer und Namen des Bildes (der Zähler allein sagt nicht, was zu sehen ist)
        var ans = d.querySelector('.vc-lx__ansage'), name = x.titel || x.alt || '';
        var satz = (n > 1 ? (x.typ === 'video' ? 'Video ' : 'Bild ') + (i + 1) + ' von ' + n : '') + (name ? (n > 1 ? ': ' : '') + name : '');
        ans.textContent = '';
        clearTimeout(lb._ansT);
        lb._ansT = setTimeout(function () { ans.textContent = satz; }, 80);
        var t = d.querySelector('.vc-lx__titel'), tx = d.querySelector('.vc-lx__text'), l = d.querySelector('.vc-lx__link');
        t.textContent = x.titel || ''; t.hidden = !x.titel;
        tx.textContent = x.text || ''; tx.hidden = !x.text;
        var fokus = document.activeElement;
        if (fokus === l && !x.link) fokus = null;
        if (x.link) { l.href = x.link; l.textContent = x.linkText || 'Ansehen'; l.hidden = false; } else { l.hidden = true; l.removeAttribute('href'); }
        var zurueck = d.querySelector('.vc-lx__zurueck'), weiter = d.querySelector('.vc-lx__weiter');
        lb.stand();
        // Lag der Fokus auf einem Knopf, der jetzt aus ist (erstes oder letztes Bild), oder auf dem weggefallenen Link:
        // Fokus bleibt im Dialog, auf dem anderen Pfeil oder dem Schließen-Knopf
        if (fokus === null || ((fokus === zurueck || fokus === weiter) && fokus.disabled)) {
          var ersatz = fokus === zurueck ? weiter : zurueck;
          if (!ersatz || ersatz.disabled || ersatz.hidden) ersatz = d.querySelector('.vc-lx__zu');
          try { ersatz.focus({ preventScroll: true }); } catch (y) { ersatz.focus(); }
        }
        // Nachbarn vorladen (mit srcset, damit der Browser dieselbe Größe wählt wie gleich im Dialog), Videos nicht
        [i - 1, i + 1].forEach(function (j) {
          var nb = j >= 0 && j < n ? lb.liste[j] : null;
          if (!nb || !nb.src || nb.typ === 'video') return;
          var v = new Image();
          if (nb.srcset) { v.sizes = nb.sizes || '100vw'; v.srcset = nb.srcset; }
          v.src = nb.src;
        });
      };
      return lb;
    };
    /** Öffnet die Lightbox mit einer Liste von Bildern ab Nummer start (0 = erstes). */
    VC.lightbox = function (liste, start, ausloeser) {
      if (!liste || !liste.length) return;
      if (!vcLx || !vcLx.d.isConnected) vcLx = vcLxBauen();
      vcLx.liste = liste;
      // Schon offen (neue Liste): der ursprüngliche Auslöser bleibt das Ziel für den Fokus danach
      if (!vcLx.d.open || ausloeser) vcLx.ausloeser = ausloeser || document.activeElement;
      vcLx.zeigen(Math.max(0, Math.min(liste.length - 1, Number(start) || 0)));
      if (!vcLx.d.open) {
        vcLx.modal = typeof vcLx.d.showModal === 'function';
        if (vcLx.modal) vcLx.d.showModal(); else vcLx.d.setAttribute('open', '');
      }
      document.documentElement.classList.add('vc-lx-offen');
      var z = vcLx.d.querySelector('.vc-lx__zu');
      if (z) z.focus();
    };
    /** Hängt Einträge an die offene Liste an (z. B. wenn weitere Fotos nachgeladen sind). */
    VC.lightbox.erweitern = function (liste, neue) {
      if (!vcLx || !vcLx.d.open || vcLx.liste !== liste || !neue || !neue.length) return false;
      Array.prototype.push.apply(liste, neue);
      vcLx.stand();
      return true;
    };
    /** Lightbox aus dem HTML: data-vc-lightbox="gruppe" und data-gross="URL". */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-vc-lightbox]');
      if (!a || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var gruppe = a.getAttribute('data-vc-lightbox');
      var wurzel = a.closest('.shopify-section') || document;
      var alle = Array.prototype.slice.call(wurzel.querySelectorAll('[data-vc-lightbox]')).filter(function (x) { return x.getAttribute('data-vc-lightbox') === gruppe && x.offsetParent !== null; });
      if (!alle.length) return;
      e.preventDefault();
      VC.lightbox(alle.map(function (x) {
        return { src: x.getAttribute('data-gross'), srcset: x.getAttribute('data-srcset') || '', sizes: '100vw', alt: x.getAttribute('data-alt') || '', titel: x.getAttribute('data-titel') || '', text: x.getAttribute('data-text') || '', link: x.getAttribute('data-link') || '', linkText: x.getAttribute('data-link-text') || '' };
      }), Math.max(0, alle.indexOf(a)), a);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vc-pdp"] && !Shopify.designMode) return;
  try {
    var VC = window.VC = window.VC || {};
  if (!VC.aufVariante) {
    // Änderungen der Adresse (Impact schreibt ?variant= mit replaceState) als Ereignis "vc:url"
    if (!history.__vcUrl) {
      ['pushState', 'replaceState'].forEach(function (n) {
        var alt = history[n];
        if (typeof alt !== 'function') return;
        history[n] = function () {
          var r = alt.apply(this, arguments);
          try { window.dispatchEvent(new Event('vc:url')); } catch (e) { /* alter Browser */ }
          return r;
        };
      });
      history.__vcUrl = true;
    }
    /** Formular oder Ereignis aus dem Schnellkauf (Impact: quick-buy-drawer, Formular-ID quick-buy-form-...)? */
    var vcPdpSchnellkauf = function (el) {
      if (!el || !el.closest) return false;
      // getAttribute: bei Formularen mit einem Feld name="id" liefert form.id das Feld, nicht die ID
      var f = el.tagName === 'FORM' ? el : el.closest('form');
      if (f && /^quick-buy/.test(f.getAttribute('id') || '')) return true;
      return !!el.closest('quick-buy-drawer, quick-buy-popover');
    };
    /** Das Feld name="id" eines Formulars, auch wenn es mit form="..." außerhalb liegt. */
    var vcPdpFeld = function (f) {
      return (f.elements && f.elements.namedItem && f.elements.namedItem('id')) || (f.querySelector && f.querySelector('[name="id"]')) || null;
    };
    /**
     * fn(id) bei jeder Wahl einer der Varianten ids (Zahlen). Gibt eine Funktion zurück, die die zuletzt gemeldete
     * Variante liefert (mit .weg() zum Abmelden). start: Variante, die gilt, solange nichts gewählt ist (z. B. die
     * erste verfügbare). el: Element der Section (nicht im Dokument: nichts melden; Section entladen: abmelden).
     */
    VC.aufVariante = function (ids, fn, start, el) {
      ids = (ids || []).map(Number);
      var letzte = null, an = [];
      var hoeren = function (ziel, typ, f, erfassen) { ziel.addEventListener(typ, f, !!erfassen); an.push([ziel, typ, f, !!erfassen]); };
      var weg = function () { an.forEach(function (x) { x[0].removeEventListener(x[1], x[2], x[3]); }); an = []; };
      var pruefen = function (id) {
        id = Number(id);
        if (!id || id === letzte || ids.indexOf(id) === -1) return;
        // Gerade nicht im Dokument (im Theme-Editor verschoben): nichts melden, die nächste Wahl kommt wieder an
        if (el && !el.isConnected) return;
        letzte = id;
        try { fn(id); } catch (e) { if (window.console) console.error(e); }
      };
      // Theme-Editor: die Section wird neu gerendert oder gelöscht, das alte Element kommt nicht zurück
      if (el) hoeren(document, 'shopify:section:unload', function (e) { if (e.target && e.target.contains && e.target.contains(el)) weg(); });
      var ausUrl = function () { var m = /[?&]variant=(\d+)/.exec(window.location.search); if (m) pruefen(m[1]); };
      hoeren(document, 'variant:change', function (e) {
        if (vcPdpSchnellkauf(e.target)) return;
        var v = e.detail && (e.detail.variant || e.detail);
        if (v && v.id) pruefen(v.id);
      });
      // Rückfall für Themes ohne Ereignis: das Feld name="id". Den Stand in der Erfassungsphase merken (bevor das Theme
      // reagiert) und nur übernehmen, wenn das Feld sich danach ändert und das Formular noch im Dokument ist.
      // Auch Felder außerhalb des Formulars mit form="..." zählen (so baut Impact die Varianten-Auswahl).
      hoeren(document, 'change', function (e) {
        var t = e.target;
        var f = t && (t.form || (t.closest && t.closest('form')));
        if (!f || !f.matches || !f.matches('form[action*="/cart/add"]') || vcPdpSchnellkauf(f)) return;
        // Das Feld selbst (Auswahl der Variante, oder das Theme meldet seine Änderung): gilt sofort
        if (t.name === 'id') { pruefen(t.value); return; }
        var feld = vcPdpFeld(f);
        if (!feld) return;
        var vorher = feld.value;
        setTimeout(function () {
          var x = vcPdpFeld(f);
          if (f.isConnected && x && x.value && x.value !== vorher) pruefen(x.value);
        }, 40);
      }, true);
      hoeren(window, 'vc:url', ausUrl);
      hoeren(window, 'popstate', ausUrl);
      if (start) pruefen(start);
      ausUrl();
      var stand = function () { return letzte; };
      stand.weg = weg;
      return stand;
    };
  }
  } catch(e) { console.error(e); }
})();

})();
